import React from "react";
import { Rect } from "react-konva";

const DrawRect = ({ index, rect, fill, opacity }) => {
  return (
    <>
      <Rect
        key={index}
        name={"rect"}
        x={rect.x}
        y={rect.y}
        width={rect.width}
        height={rect.height}
        fill={fill}
        stroke="#000"
        strokeWidth={1}
        opacity={opacity}
      />
    </>
  );
};

export default DrawRect;
